import config from '../config';
import { request } from '../utils/request';

const cdnDomain = `${config.host}${config.apiRouter.cdn}`;

const api = {
  // 上传文件
  uploadFile (data = {}) {
    return request({
      method: 'POST',
      url: `${cdnDomain}/UploadFile`,
      data,
      headers: { 'Content-Type': 'multipart/form-data', 'X-Tif-Sid': 'zwopen' },
      hideLoading: true,
      timeout: 120 * 1000,
    });
  },
  // 上传 zip 文件并 unzip
  uploadZipFileAndUnzip (data = {}) {
    return request({
      method: 'POST',
      url: `${cdnDomain}/UploadZipFileAndUnzip`,
      data,
      headers: { 'Content-Type': 'multipart/form-data' },
      hideLoading: true,
      timeout: 120 * 1000,
    });
  },
  // 文件列表
  listFiles (data = {}) {
    return request({
      method: 'POST',
      url: `${cdnDomain}/ListFiles`,
      data,
    });
  },
  // 搜索文件列表
  searchFiles (data = {}) {
    return request({
      method: 'POST',
      url: `${cdnDomain}/SearchFiles`,
      data,
    });
  },
  // 批量删除文件
  deleteFiles (data = {}) {
    return request({
      method: 'POST',
      url: `${cdnDomain}/DeleteFiles`,
      data,
      hideLoading: true,
    });
  },
  DeleteFilesInUploadRecord (data = {}) {
    return request({
      method: 'POST',
      url: `${cdnDomain}/DeleteFilesInUploadRecord`,
      data,
      hideLoading: true,
    });
  },
  // 获取 unzipped zip 包中的文件列表
  listFilesInUnzippedZipFile (data = {}) {
    return request({
      method: 'POST',
      url: `${cdnDomain}/ListFilesInUnzippedZipFile`,
      data,
    });
  },
  // 覆盖上传 zip包
  UploadZipFileAndUnzipAndCoverExisting (data = {}) {
    return request({
      method: 'POST',
      url: `${cdnDomain}/UploadZipFileAndUnzipAndCoverExisting`,
      data,
      hideLoading: true,
    });
  },
  // 获取文件详情
  getFiles (data = {}, headers = {}) {
    return request({
      method: 'POST',
      url: `${cdnDomain}/GetFiles`,
      data,
      headers,
    });
  },
  // 刷新cdn
  refreshURLs (data = {}) {
    return request({
      method: 'POST',
      url: `${cdnDomain}/RefreshURLs`,
      data,
      hideLoading: true,
    });
  },
  // 获取cdn刷新剩余次数
  getRefreshURLRemainRation (data = {}) {
    return request({
      method: 'POST',
      url: `${cdnDomain}/GetRefreshURLRemainRation`,
      data,
    });
  },
  // 获取文件的历史覆盖信息
  RecoverCoverLogInFile (data = {}) {
    return request({
      method: 'POST',
      url: `${cdnDomain}/RecoverCoverLogInFile`,
      data,
    });
  },
  // 回滚文件
  ListCoverLogsInFile (data = {}) {
    return request({
      method: 'POST',
      url: `${cdnDomain}/ListCoverLogsInFile`,
      data,
    });
  },
  // 获取历史上传记录
  ListUploadRecords (data = {}) {
    return request({
      method: 'POST',
      url: `${cdnDomain}/ListUploadRecords`,
      data,
    });
  },
  // 通过上传记录id获取本批次上传文件列表
  ListFilesWithUploadRecordID (data = {}) {
    return request({
      method: 'POST',
      url: `${cdnDomain}/ListFilesWithUploadRecordID`,
      data,
    });
  },
};
export default api;
